var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMedal = function SvgMedal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 17 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M13.331 6c0 .967-.286 1.854-.78 2.594a4.657 4.657 0 0 1-3.186 2.013c-.227.04-.46.06-.7.06-.24 0-.474-.02-.7-.06a4.657 4.657 0 0 1-3.187-2.013A4.645 4.645 0 0 1 3.998 6a4.663 4.663 0 0 1 4.667-4.667A4.663 4.663 0 0 1 13.33 6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "m14.833 12.313-1.1.26a.654.654 0 0 0-.493.494l-.233.98a.667.667 0 0 1-1.16.273l-3.18-3.653-3.18 3.66a.667.667 0 0 1-1.16-.274l-.234-.98a.664.664 0 0 0-.493-.493l-1.1-.26a.669.669 0 0 1-.32-1.12l2.6-2.6a4.657 4.657 0 0 0 3.187 2.013c.226.04.46.06.7.06.24 0 .473-.02.7-.06A4.657 4.657 0 0 0 12.553 8.6l2.6 2.6c.367.36.187.993-.32 1.113ZM9.053 3.986l.394.787a.483.483 0 0 0 .32.234l.713.12c.453.073.56.406.233.733l-.553.553a.472.472 0 0 0-.113.407l.16.686c.126.54-.16.754-.64.467L8.9 7.58a.467.467 0 0 0-.44 0l-.667.393c-.48.28-.766.074-.64-.466l.16-.687a.5.5 0 0 0-.113-.407l-.553-.553c-.327-.327-.22-.654.233-.734l.713-.12c.12-.02.26-.126.314-.233l.393-.786c.193-.427.54-.427.753 0Z"
  })));
};
export default SvgMedal;